import { tasks } from "../../constants/apiUrl";
import { IWorkloadData } from "../../models/faculty/facultyWorkload";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";

export default new (class FacultyWorkloadService {
  public getWorkload = async (): Promise<IApiResponse<IWorkloadData>> => {
    try {
      let endPoint = tasks.GET_WORKLOAD
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IWorkloadData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IWorkloadData>;
      } else {
        throw error;
      }
    }
  };
});